import { render, staticRenderFns } from "./pendingBetList9WExportFull.vue?vue&type=template&id=8aae3d12&lang=pug"
import script from "./pendingBetList9WExportFull.vue?vue&type=script&lang=js"
export * from "./pendingBetList9WExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports